// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>35</span>&nbsp;&nbsp;Wait upon the Lord and keep his way;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;he will raise you up to possess the land,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and when the wicked are uprooted, you shall see it.<br> </p> </div></div>";
// Exports
module.exports = code;